import { AlertTriangle } from 'lucide-react';
import { LegalLayout } from '../components/legal/LegalLayout';
import styles from './legal/Legal.module.css';

export function TermsOfService() {
  return (
    <LegalLayout
      label="Terms of Service"
      title="User Agreement"
      subtitle="The rules and safety guidelines for using our diagnostic service."
      lastUpdated="May 14, 2026"
    >
      <h2>1. Service Description</h2>
      <p>PCCheckr provides AI-assisted Windows diagnostic guidance. The reports generated are intended to identify potential hardware and software issues using technical metadata collected from your system.</p>
      
      <h2>2. Informational Purpose Only</h2>
      <p>All reports and suggestions provided by PCCheckr are for informational purposes only. PCCheckr does not guarantee specific repair outcomes or that the system will be fixed by following the provided guidance.</p>
      
      <h2>3. User Responsibility</h2>
      <p>Users are solely responsible for applying any fixes, modifications, or software changes suggested in the reports. We strongly recommend that advanced actions or hardware repairs be reviewed by a qualified IT technician before implementation.</p>
      
      <h2>4. Limitation of Liability</h2>
      <p>PCCheckr provides no warranty for data loss, device damage, software corruption, or any issues arising from the misuse of third-party tools suggested in our reports. You use this service at your own risk.</p>
      
      <h2>5. External Links & Tools</h2>
      <p>PCCheckr may provide links to official manufacturer or Microsoft support pages. Users should only download tools and drivers from these official sources to ensure system safety.</p>
      
      <h2>6. Purchase Terms</h2>
      <p>PCCheckr does not operate on a subscription basis. All credits are one-time purchases and entitle the user to a defined number of diagnostic reports.</p>
      
      <div className={styles.trustNotice}>
        <AlertTriangle className={styles.trustIcon} size={24} />
        <p>Reports are informational. For critical hardware issues, always consult a certified professional.</p>
      </div>
    </LegalLayout>
  );
}
